/*
 * @Author: zloongjiang
 * @Date: 2021-07-08 19:00:16
 * @Last Modified by: zloongjiang
 * @Last Modified time: 2021-07-12 16:58:10
 */
// @flow
import C4PV from './C4PV';
import { reportAccess } from '../fetchers/PV';

/**
 * 上报推荐相关(相关推荐 + 作者热文) 【后台曝光\后台点击\真实曝光点击】
 */
const LOGTYPE = {
  qb_exposure: 'qb_exposure', // 后台曝光
  qb_statistic: 'qb_statistic', // 后台点击
  qb_terminal_exposure: 'qb_terminal_exposure', // 严口径曝光
  qb_custom: 'qb_custom', // 自定义日志
};
let userData = null;

// 产品TAPD: http://tapd.oa.com/kandian_platform_RD/prong/stories/view/1020420395865734517

export default class ReportRecommend {
  static async report(logData: Object, logType: string = '') {
    if (!logType || !LOGTYPE[logType]) return;
    if (!userData) {
      // eslint-disable-next-line new-cap
      userData = await C4PV();
    }
    const commonParams = {
      F9: 13, // product_id, 13表推荐
    };
    reportAccess(
      {
        ...Object.assign(commonParams, logData),
        ...userData,
      },
      logType,
    );
  }
  // 后台曝光
  static async qbExposure(params: Object = {}) {
    const {
      ch = '',
      senceId = '',
      docId = '',
      sGrayPlatFormModelId = '',
      busiType = '',
      innerCh = '',
      productId = '',
    } = params;
    const logParams = {
      F7: ch,
      F8: innerCh,
      F9: productId,
      F10: senceId, // 1=相关推荐；3=作者热文
      F12: 1, // 推荐
      F13: busiType, // 1=图文
      F15: docId,
      F16: sGrayPlatFormModelId,
    };
    this.report(logParams, LOGTYPE.qb_exposure);
  }
  // 后台点击
  // static async qbStatistic() {
  // }
  // 真实曝光&点击
  static async qbTerminalExposure(params: Object = {}) {
    const {
      action = '',
      senceId = '',
      docId = '',
      ch = '',
      sGrayPlatFormModelId = '',
      data_type: dataType,
      productId = 13,
      vid = '',
      innerCh = '',
      dataSrc = 1,
      auto = 0,
    } = params;
    const logParams = {
      F7: action, // 0:曝光/1:点击
      F8: ch,
      F9: productId,
      F10: senceId, // 1=相关推荐；3=作者热文
      F12: sGrayPlatFormModelId,
      F11: dataSrc, // 1=机器推荐
      F16: innerCh,
      F17: dataType, // 1=图文
      F26: vid || docId,
      F45: auto,
    };
    if (dataType === 3) logParams.F50 = docId;
    else if (dataType === 19) logParams.F47 = docId;
    this.report(logParams, LOGTYPE.qb_terminal_exposure);
  }
  // 图文底部推荐视频自定义日志上报
  static async qbCustomReport(type) {
    const logParams = {
      F7: 'clicklog',
      F8: 2,
      F9: type,
    };
    this.report(logParams, LOGTYPE.qb_custom);
  }
}
